export enum HttpStatusCode {
  OK = 200,
  CREATED = 201,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  UNPROCESSABLE_CONTENT = 422,
  INTERNAL_SERVER_ERROR = 500,
}

export enum MediaType {
  IMAGE = "Image",
  VIDEO = "Video",
  DOCUMENT = "Document",
  AUDIO = "Audio",
}

export enum MediaDirectoryKeys {
  Category = "category",
  ProductVariant = "product-variant",
  InventoryManager = "inventory-manager",
  Admin = "admin",
  Reseller = "reseller",
  Verification = "verification",
  Offer = "special-offer",
  OfferSectionStyle = "special-offer-section-style",
  ProductSharing = "product-sharing",
  Banner = "banner",
  ExpenseProof = "expense",
  ProductFeedInsert = "product-feed-insert",
  ProductSet = "product-set",
  Announcement = "announcement",
  DeliveryCompany = "delivery-company",
  ProductUsageGuide = "product-usage-guide",
}

export enum Gender {
  All = "All",
  Male = "Male",
  Female = "Female",
}
